'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'face-angry';
var width = 512;
var height = 512;
var aliases = [128544,"angry"];
var unicode = 'f556';
var svgPathData = 'M338.7 395.9C332.1 401.8 322 401.3 316.1 394.7C304.4 381.7 284.5 368 256 368C227.5 368 207.6 381.7 195.9 394.7C189.1 401.3 179.9 401.8 173.3 395.9C166.7 389.1 166.2 379.9 172.1 373.3C188.2 355.4 216.3 336 256 336C295.7 336 323.8 355.4 339.9 373.3C345.8 379.9 345.3 389.1 338.7 395.9H338.7zM152.4 240C152.4 231.9 156.4 224.7 162.5 220.4L122.9 207.2C114.6 204.4 110 195.3 112.8 186.9C115.6 178.6 124.7 174 133.1 176.8L229.1 208.8C237.4 211.6 241.1 220.7 239.2 229.1C236.4 237.4 227.3 241.1 218.9 239.2L199.2 232.6C199.1 234.9 200.4 237.4 200.4 240C200.4 253.3 189.6 264 176.4 264C163.1 264 152.4 253.3 152.4 240H152.4zM360.4 240C360.4 253.3 349.6 264 336.4 264C323.1 264 312.4 253.3 312.4 240C312.4 237.3 312.8 234.7 313.6 232.3L293.1 239.2C284.7 241.1 275.6 237.4 272.8 229.1C270 220.7 274.6 211.6 282.9 208.8L378.9 176.8C387.3 174 396.4 178.6 399.2 186.9C401.1 195.3 397.4 204.4 389.1 207.2L349.1 220.2C356.2 224.5 360.4 231.8 360.4 240H360.4zM0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32C132.3 32 32 132.3 32 256C32 379.7 132.3 480 256 480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceAngry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;